/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdvancedReportsAgentCallsResponse } from '../models/AdvancedReportsAgentCallsResponse';
import type { AdvancedReportsAgentHourlyConnectedCallsResponse } from '../models/AdvancedReportsAgentHourlyConnectedCallsResponse';
import type { AdvancedReportsAgentHourlyFilters } from '../models/AdvancedReportsAgentHourlyFilters';
import type { AdvancedReportsAgentPerformanceFilters } from '../models/AdvancedReportsAgentPerformanceFilters';
import type { AdvancedReportsAgentPerformanceResponse } from '../models/AdvancedReportsAgentPerformanceResponse';
import type { AdvancedReportsConfigResponse } from '../models/AdvancedReportsConfigResponse';
import type { AdvancedReportsConnectedMinutesFilters } from '../models/AdvancedReportsConnectedMinutesFilters';
import type { AdvancedReportsConnectedMinutesResponse } from '../models/AdvancedReportsConnectedMinutesResponse';
import type { AdvancedReportsContactabilityByPhoneFilters } from '../models/AdvancedReportsContactabilityByPhoneFilters';
import type { AdvancedReportsContactabilityByPhoneResponse } from '../models/AdvancedReportsContactabilityByPhoneResponse';
import type { AdvancedReportsExtractionsFilters } from '../models/AdvancedReportsExtractionsFilters';
import type { AdvancedReportsExtractionsResponse } from '../models/AdvancedReportsExtractionsResponse';
import type { AdvancedReportsFeaturedCallsResponse } from '../models/AdvancedReportsFeaturedCallsResponse';
import type { AdvancedReportsLeadQualificationResponse } from '../models/AdvancedReportsLeadQualificationResponse';
import type { AdvancedReportsObjectionsFilters } from '../models/AdvancedReportsObjectionsFilters';
import type { AdvancedReportsObjectionsResponse } from '../models/AdvancedReportsObjectionsResponse';
import type { AdvancedReportsOutgoingCallContactabilityResponse } from '../models/AdvancedReportsOutgoingCallContactabilityResponse';
import type { AdvancedReportsOutgoingCallVolumeResponse } from '../models/AdvancedReportsOutgoingCallVolumeResponse';
import type { AdvancedReportsTeamUserFilters } from '../models/AdvancedReportsTeamUserFilters';
import type { AdvancedReportsTimeSeriesFilters } from '../models/AdvancedReportsTimeSeriesFilters';
import type { ReportDashboardConfig } from '../models/ReportDashboardConfig';
import type { ReportDashboardView } from '../models/ReportDashboardView';
import type { ReportFunnelStatusFunnelFilters } from '../models/ReportFunnelStatusFunnelFilters';
import type { ReportFunnelStatusFunnelResponse } from '../models/ReportFunnelStatusFunnelResponse';
import type { ReportFunnelStatusTimeseriesFilters } from '../models/ReportFunnelStatusTimeseriesFilters';
import type { ReportFunnelStatusTimeseriesResponse } from '../models/ReportFunnelStatusTimeseriesResponse';
import type { ReportPropertyInterestRankingFilters } from '../models/ReportPropertyInterestRankingFilters';
import type { ReportPropertyInterestRankingResponse } from '../models/ReportPropertyInterestRankingResponse';
import type { ReportPropertyTypeDistributionFilters } from '../models/ReportPropertyTypeDistributionFilters';
import type { ReportPropertyTypeDistributionResponse } from '../models/ReportPropertyTypeDistributionResponse';
import type { ReportUserAssignmentRankingFilters } from '../models/ReportUserAssignmentRankingFilters';
import type { ReportUserAssignmentRankingResponse } from '../models/ReportUserAssignmentRankingResponse';
import type { ReportUserOption } from '../models/ReportUserOption';
import type { ReportWidgetCatalogItem } from '../models/ReportWidgetCatalogItem';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ReportsService {
    /**
     * @returns ReportWidgetCatalogItem Ok
     * @throws ApiError
     */
    public static getReportWidgetsCatalog(): CancelablePromise<Array<ReportWidgetCatalogItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/widgets/catalog',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ReportUserOption Ok
     * @throws ApiError
     */
    public static getReportWidgetUsers(): CancelablePromise<Array<ReportUserOption>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/widgets/users',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ReportDashboardView Ok
     * @throws ApiError
     */
    public static getReportDashboard(): CancelablePromise<ReportDashboardView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/dashboard',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ReportDashboardView Ok
     * @throws ApiError
     */
    public static updateReportDashboard(
        requestBody: ReportDashboardConfig,
    ): CancelablePromise<ReportDashboardView> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/reports/dashboard',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ReportDashboardView Ok
     * @throws ApiError
     */
    public static deleteReportDashboard(): CancelablePromise<ReportDashboardView> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/reports/dashboard',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ReportFunnelStatusFunnelResponse Ok
     * @throws ApiError
     */
    public static queryFunnelStatusFunnelWidget(
        requestBody: ReportFunnelStatusFunnelFilters,
    ): CancelablePromise<ReportFunnelStatusFunnelResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/widgets/funnel-status-funnel/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ReportFunnelStatusTimeseriesResponse Ok
     * @throws ApiError
     */
    public static queryFunnelStatusTimeseriesWidget(
        requestBody: ReportFunnelStatusTimeseriesFilters,
    ): CancelablePromise<ReportFunnelStatusTimeseriesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/widgets/funnel-status-timeseries/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ReportPropertyTypeDistributionResponse Ok
     * @throws ApiError
     */
    public static queryPropertyTypeDistributionWidget(
        requestBody: ReportPropertyTypeDistributionFilters,
    ): CancelablePromise<ReportPropertyTypeDistributionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/widgets/property-type-distribution/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ReportPropertyInterestRankingResponse Ok
     * @throws ApiError
     */
    public static queryPropertyInterestRankingWidget(
        requestBody: ReportPropertyInterestRankingFilters,
    ): CancelablePromise<ReportPropertyInterestRankingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/widgets/property-interest-ranking/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ReportUserAssignmentRankingResponse Ok
     * @throws ApiError
     */
    public static queryUserAssignmentRankingWidget(
        requestBody: ReportUserAssignmentRankingFilters,
    ): CancelablePromise<ReportUserAssignmentRankingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/widgets/user-assignment-ranking/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns AdvancedReportsConfigResponse Ok
     * @throws ApiError
     */
    public static getAdvancedReportsConfig(): CancelablePromise<AdvancedReportsConfigResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/advanced/config',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdvancedReportsAgentPerformanceResponse Ok
     * @throws ApiError
     */
    public static queryAgentPerformance(
        requestBody: AdvancedReportsAgentPerformanceFilters,
    ): CancelablePromise<AdvancedReportsAgentPerformanceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/advanced/agent-performance/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdvancedReportsAgentCallsResponse Ok
     * @throws ApiError
     */
    public static queryAgentCalls(
        requestBody: AdvancedReportsTimeSeriesFilters,
    ): CancelablePromise<AdvancedReportsAgentCallsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/advanced/agent-calls/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdvancedReportsFeaturedCallsResponse Ok
     * @throws ApiError
     */
    public static queryFeaturedCalls(
        requestBody: AdvancedReportsTimeSeriesFilters,
    ): CancelablePromise<AdvancedReportsFeaturedCallsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/advanced/featured-calls/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdvancedReportsAgentHourlyConnectedCallsResponse Ok
     * @throws ApiError
     */
    public static queryAgentHourlyConnectedCalls(
        requestBody: AdvancedReportsAgentHourlyFilters,
    ): CancelablePromise<AdvancedReportsAgentHourlyConnectedCallsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/advanced/agent-hourly-connected-calls/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdvancedReportsOutgoingCallVolumeResponse Ok
     * @throws ApiError
     */
    public static queryOutgoingCallVolume(
        requestBody: AdvancedReportsTeamUserFilters,
    ): CancelablePromise<AdvancedReportsOutgoingCallVolumeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/advanced/outgoing-call-volume/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdvancedReportsOutgoingCallContactabilityResponse Ok
     * @throws ApiError
     */
    public static queryOutgoingCallContactability(
        requestBody: AdvancedReportsTeamUserFilters,
    ): CancelablePromise<AdvancedReportsOutgoingCallContactabilityResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/advanced/outgoing-call-contactability/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdvancedReportsObjectionsResponse Ok
     * @throws ApiError
     */
    public static queryObjections(
        requestBody: AdvancedReportsObjectionsFilters,
    ): CancelablePromise<AdvancedReportsObjectionsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/advanced/objections/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdvancedReportsLeadQualificationResponse Ok
     * @throws ApiError
     */
    public static queryLeadQualification(
        requestBody: AdvancedReportsTimeSeriesFilters,
    ): CancelablePromise<AdvancedReportsLeadQualificationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/advanced/lead-qualification/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdvancedReportsConnectedMinutesResponse Ok
     * @throws ApiError
     */
    public static queryConnectedMinutes(
        requestBody: AdvancedReportsConnectedMinutesFilters,
    ): CancelablePromise<AdvancedReportsConnectedMinutesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/advanced/connected-minutes/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdvancedReportsExtractionsResponse Ok
     * @throws ApiError
     */
    public static queryExtractions(
        requestBody: AdvancedReportsExtractionsFilters,
    ): CancelablePromise<AdvancedReportsExtractionsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/advanced/extractions/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdvancedReportsContactabilityByPhoneResponse Ok
     * @throws ApiError
     */
    public static queryContactabilityByPhone(
        requestBody: AdvancedReportsContactabilityByPhoneFilters,
    ): CancelablePromise<AdvancedReportsContactabilityByPhoneResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/advanced/contactability-by-phone/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
